import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const AttractionCtx = createContext(null);

export function AttractionProvider({ children }) {
  const { user } = useAuth();
  const [attraction, setAttraction] = useState(null);

  const refresh = useCallback(async () => {
    if (!user || !user.attraction_id) { setAttraction(null); return; }
    try { const r = await api.get("/attractions/me"); setAttraction(r.data); }
    catch { setAttraction(null); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AttractionCtx.Provider value={{ attraction, refresh, setAttraction }}>
      {children}
    </AttractionCtx.Provider>
  );
}

export const useAttraction = () => useContext(AttractionCtx);
